module.exports = __webpack_public_path__ + "static/media/icon-missing-asset-grey.d3250e90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/icon-missing-asset-grey.svg
// module id = 106
// module chunks = 57